export const COMMON_BUTTON_PROPS = {
    bg: 'brand.lightTertiary',
    color: 'common.white',
    fontSize: '12.8px',
    lineHeight: '15px',
    fontWeight: '400',
    h: '32px',
    w: { base: '70px', sm: '80px' },
    border: '1px solid button.blue',
    borderRadius: '2px',
    _hover: {
        bg: 'brand.tertiary',
        color: 'common.white',
    }
};

export const TAB_HEADER_PROPS = {
    textStyle: 'h2',
    mb: '16px',
    bg: 'brand.tertiary',
    minH: '32px',
    color: 'common.white',
    padding: '8px 16px',
    borderRadius: '2px',
};

export const MAIN_HEADER_PROPS = {
    textStyle: 'h2',
    bg: 'brand.tertiary',
    color: 'brand.secondary',
    padding: '8px 16px',
    borderRadius: '2px',
};

export const BUTTON_SECTION_PROPS = {
    padding: { base: '8px', sm: '8px 16px' },
    alignItems: 'center',
    justifyContent: 'center'
};

export const RATE_SECTION_PROPS = {
    padding: { base: '8px', sm: '8px 16px' },
    alignItems: 'center',
    gap: '8px',
};

export const AMENITIES_SECTION_PROPS = {
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    padding: '8px',
};